import "./Loader.scss";
import React, { useEffect } from "react";
import logo from "../../../assets/images/xpoc-logo.svg";

interface LoadingProps {
    isLoading: boolean;
}

const Loader: React.FC<LoadingProps> = ({ isLoading }) => {
    useEffect(() => {
        if (isLoading) {
            document.body.style.overflow = "hidden";
            document.body.style.height = "100%";
        } else {
            document.body.style.overflow = "";
            document.body.style.height = "";
        }
        return () => {
            document.body.style.overflow = "";
            document.body.style.height = "";
        };
    }, [isLoading]);

    return (
        <>
            {isLoading && (
                <div className="div-loading">
                    <div className="loader-inner">
                        <div className="loader"></div>
                        <p className="loading-text font-Mulish font-bold text-darkcolor-100 text-[22px]">
                            Loading...
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};

export default Loader;
